"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CODE_EXCHANGE = void 0;
const client_1 = require("@apollo/client");
exports.CODE_EXCHANGE = client_1.gql `
  mutation codeExchange($input: CodeExchange!) {
    codeExchange(input: $input) {
      accessToken
      refreshToken
      expiresIn
    }
  }
`;
